import {
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const ChatHistoryModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.chatHistory,
  templateType: ModuleTemplateTypeEnum.getContent,
  flowType: FlowNodeTypeEnum.chatHistory,
  avatar: '/imgs/module/AI.png',
  name: '对话记录获取',
  description: '获取用户最新一条输入内容前数条的对话内容',
  inputs: [
    Input_Template_Switch,
    {
      key: ModuleInputKeyEnum.chatId,
      type: FlowNodeInputTypeEnum.hidden,
      label: 'chatId',
      value: '{chatId}',
      required: true,
    },
    {
      key: ModuleInputKeyEnum.chatMsgCount,
      type: FlowNodeInputTypeEnum.numberInput,
      label: '消息条数',
      value: 6,
      valueType: ModuleIOValueTypeEnum.number,
      showTargetInApp: true,
      showTargetInPlugin: true,
      description: '获取对话记录的条数',
      required: true,
    },
    {
      key: ModuleInputKeyEnum.chatHistoryUrl,
      type: FlowNodeInputTypeEnum.hidden, // Set in the pop-up window
      label: '获取对话记录的url',
      description: '获取对话记录的url',
      value: 'xxx',
      valueType: ModuleIOValueTypeEnum.string,
    },
  ],
  outputs: [
    Output_Template_Finish,
    {
      key: ModuleOutputKeyEnum.chatHistory,
      label: '对话记录',
      description: '用户最新一条输入内容前的数条聊天记录',
      valueType: ModuleIOValueTypeEnum.chatHistory,
      type: FlowNodeOutputTypeEnum.source,
      targets: [],
    },
  ],
};
